<!-- Si el padre pasa su propio canvas (mychart), se dibuja ahí y aquí no va nada. -->
<div class="chart-container" *ngIf="!mychart">
    <canvas #propio></canvas>
</div>
